import { CodeSyntax } from '@carbon/pictograms-react';
import { NetworkServices } from '@carbon/pictograms-react';
import { CarbonForIbmDotcom } from '@carbon/pictograms-react';
import { Kubernetes } from '@carbon/pictograms-react';
import { AppDeveloper } from '@carbon/pictograms-react';
import { AcceleratedComputing } from '@carbon/pictograms-react';
import { Construct } from '@carbon/pictograms-react';
import { ServerOperatingSystems } from '@carbon/pictograms-react';
import { NaturalLanguageUnderstanding } from '@carbon/pictograms-react';
import * as React from 'react';
export default {
  CodeSyntax,
  NetworkServices,
  CarbonForIbmDotcom,
  Kubernetes,
  AppDeveloper,
  AcceleratedComputing,
  Construct,
  ServerOperatingSystems,
  NaturalLanguageUnderstanding,
  React
};